import React, { useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useAuth } from "@likemagic-tech/sv-magic-library";
import { Loading } from "../components/loading";
import { LoadingShadow } from "../components/loading-shadow";
import { DeadLettersTable } from "../dead-letters/components/dead-letters-table";
import { useDeadLettersPage } from "../dead-letters/hooks/use-dead-letters-page";
import { DeadLetterApi } from "../dead-letters/api/dead-letter.api";

export const DeadLettersPage: React.FC = () => {
  const auth = useAuth();
  DeadLetterApi.setKeycloak(auth.keycloak);

  const {
    data,
    loading,
    error,
    forbidden,
    page,
    rowsPerPage,
    filters,
    debouncedFilters,
    resendingId,
    resendResult,
    fetchData,
    handleChangePage,
    handleChangeRowsPerPage,
    handleFilterChange,
    resend,
    clearResendResult,
  } = useDeadLettersPage();

  useEffect(() => {
    // Wait for Keycloak, or the first request goes out without a token.
    if (!auth.initialized) {
      return;
    }
    fetchData(page, rowsPerPage, debouncedFilters);
  }, [auth.initialized, fetchData, page, rowsPerPage, debouncedFilters]);

  if (forbidden) {
    return <Alert severity="warning">{error}</Alert>;
  }

  if (!data) {
    return error ? <Alert severity="error">{error}</Alert> : <Loading />;
  }

  return (
    <>
      {error && <Alert severity="error">{error}</Alert>}
      <LoadingShadow loading={loading}>
        <DeadLettersTable
          data={data}
          filters={filters}
          resendingId={resendingId}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleFilterChange={handleFilterChange}
          onResend={resend}
        />
      </LoadingShadow>
      <Snackbar
        open={!!resendResult}
        autoHideDuration={resendResult?.success ? 6000 : null}
        onClose={clearResendResult}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={resendResult?.success ? "success" : "error"}
          onClose={clearResendResult}
        >
          {resendResult?.message}
        </Alert>
      </Snackbar>
    </>
  );
};
